
export const GuardarPrioridad = (prioridad, idPrioridad) => {
    const data = new FormData();
    data.append('prioridad', prioridad)
    data.append('idPrioridad', idPrioridad)
    return new Promise((resolve, reject) => {
        fetch(process.env.REACT_APP_API_URL+'/prioridades.php?funcion=agregarPrioridad',{
            method:'POST',
            body:data
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}
export const EliminarPrioridad = (prioridad) => {
    const data = new FormData();
    data.append('idPrioridad', prioridad)
    data.append('idPrioridad', prioridad)
    return new Promise((resolve, reject) => {
        fetch(process.env.REACT_APP_API_URL+'/prioridades.php?funcion=eliminarPrioridad',{
            method:'POST',
            body:data
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}